var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { TimerCountdown } from "../generic/timer/TimerCountdown";
var MarketTimerCountdown = /** @class */ (function (_super) {
    __extends(MarketTimerCountdown, _super);
    function MarketTimerCountdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketTimerCountdown.prototype.render = function () {
        var remainingTime = this.props.remainingTime;
        return (React.createElement("div", { className: "market-menu__timer" },
            React.createElement("div", { className: IdStyles.TextBoldAccent },
                React.createElement(TimerCountdown, { remainingTime: remainingTime }))));
    };
    return MarketTimerCountdown;
}(React.Component));
export { MarketTimerCountdown };



//////////////////
// WEBPACK FOOTER
// ./src/features/market/MarketTimerCountdown.tsx
// module id = 933
// module chunks = 3